module.exports = __webpack_public_path__ + "static/media/ilustration-signup-gartner.5a66c327.png";